const DevTools = {};
DevTools.instrument = () => null;

export default DevTools;



// WEBPACK FOOTER //
// ./src/store/DevTools/DevTools.prd.js